import { IOrganization } from '../Interfaces/IOrganization';

export const organizationModel: IOrganization = {
  name: '',
  displayName: '',
  creationDate: new Date(),
  services: {
    bots: true,
    activeTemplate: false,
    altaTemplate: false,
    notifications: false,
    practices: false,
  },
  provider: {
    appName: '',
    dfId: '',
    name: 'gupshup',
    phone: '',
  },
  healthSoftware: {
    name: 'decisionTree',
  },
  businessRules: {
    apiCache: {
      endpoints: ['prestadores/v2/disponibles/true'],
      isActive: false,
    },
    filterOsPlan: false,
    showAppointmentPrep: false,
    misChats: true,
    responseLimit: 0,
    lastPatientInsurance: false,
    pacienteSinFicha: false,
    appointmentsModality: {
      inPerson: {
        messages: {
          savedAppImportantInfo: '',
          savedAppPostMessage: '',
          savedAppPreMessage: '',
        },
      },
      telemedicine: {
        messages: {
          savedAppImportantInfo: '',
          savedAppPostMessage: '',
          savedAppPreMessage: '',
        },
      },
    },
    notificationsRules: {
      isPrestoBotsService: false,
      deliveryTimeRanges: [
        { from: 8, to: 14 },
        { from: 16, to: 21 },
      ],
      daysProirForDelivery: 2,
      batchNumberPerDelivery: 100,
      filterExtraAppointments: false,
      deliveryOnWeekend: false,
      automatedCancelationApps: false,
      cancellationOffset: 12,
    },
    institucionalMessageMedia: false,
    useAlternativePlanName: false,
    workingDays: [
      {
        day: 'lunes',
        isOpen: true,
      },
      {
        day: 'martes',
        isOpen: true,
      },
      {
        day: 'miércoles',
        isOpen: true,
      },
      {
        day: 'jueves',
        isOpen: true,
      },
      {
        day: 'viernes',
        isOpen: true,
      },
      {
        day: 'sábado',
        isOpen: false,
      },
      {
        day: 'domingo',
        isOpen: false,
      },
    ],
  },
  configuration: {
    initialMessagesWeb: [],
    initialMessagesWsp: [],
    image: '',
    mainColor: '',
  },
  billingData: { initial: 1, scaleBilling: false, specialties: [] },
  blackList: [],
  templates: [],
  disabled: false,
};
